import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  private domain = environment.url;
  private domainActivo = environment.url_activos_ti;
  constructor(private http: HttpClient) { }

  upload_file_personal(fileData: File, dni: string, nombre: string): Observable<any> {
    const url = `${this.domain}/personal/subir_archivo`;
    var formData: any = new FormData();
    formData.append('nombre', String(nombre));
    formData.append('file_data', fileData);
    formData.append('dni', dni);
    return this.http.post(url, formData, { reportProgress: true, observe: 'events' }).pipe(catchError(this.errorMgmt));
  }

  upload_file_activo(fileData: File, dni: string, nombre: string): Observable<any> {
    const url = `${this.domainActivo}/activoti/subir_archivo`;
    var formData: any = new FormData();
    formData.append('nombre', String(nombre));
    formData.append('file_data', fileData);
    formData.append('dni', dni);
    return this.http.post(url, formData, { reportProgress: true, observe: 'events' }).pipe(catchError(this.errorMgmt));
  }

  download_file_activo(prefijo: string, nro_documento: string, extension: string) {
    const url = `${this.domainActivo}/activoti/mostrar_archivo`;
    const body = JSON.stringify({
      prefijo: prefijo,
      nro_documento: nro_documento,
      extension: extension
    });
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post(url, body, { headers: headers, responseType: 'blob' });
  }

  download_file_personal(prefijo: string, nro_documento: string, extension: string) {
    const url = `${this.domain}/personal/mostrar_archivo`;
    const body = JSON.stringify({
      prefijo: prefijo,
      nro_documento: nro_documento,
      extension: extension
    });
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post(url, body, { headers: headers, responseType: 'blob' });
  }

  download_file_ayuda(nameDocumento: string, extension: string) {
    const url = `${this.domain}/personal/mostrar_archivo_ayuda`;
    const body = JSON.stringify({
      nameDocumento: nameDocumento,
      extension: extension
    });
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post(url, body, { headers: headers, responseType: 'blob' });
  }

  errorMgmt(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
}
